"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.announceDeployment = announceDeployment;
exports["default"] = void 0;
exports.get = get;
exports.getCount = getCount;
exports.getNotificationTypes = getNotificationTypes;
exports.sendLastReminderToEmployees = sendLastReminderToEmployees;
exports.update = update;
exports.updateToSeen = updateToSeen;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var baseUrl = '/api/notification';

function get(limit, offset) {
  var fetchUrl = baseUrl;

  if (limit) {
    fetchUrl = "".concat(baseUrl, "?limit=").concat(limit, "&offset=").concat(offset);
  }

  return _api["default"].get(fetchUrl).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCount() {
  return _api["default"].get("".concat(baseUrl, "/count")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getNotificationTypes() {
  return _api["default"].get("".concat(baseUrl, "/notification-types")).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(notificationId, data) {
  return _api["default"].put("".concat(baseUrl, "/").concat(notificationId), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateToSeen() {
  return _api["default"].put("".concat(baseUrl, "/seen")).then(_api.extractData)["catch"](_api.errorHandler);
}

function announceDeployment(data) {
  return _api["default"].post("".concat(baseUrl, "/announce-deployment"), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendLastReminderToEmployees() {
  return _api["default"].post("".concat(baseUrl, "/deployment-last-reminder")).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: get,
  getCount: getCount,
  getNotificationTypes: getNotificationTypes,
  update: update,
  updateToSeen: updateToSeen,
  announceDeployment: announceDeployment
};
var _default = api;
exports["default"] = _default;